import { TvmFormSubmitResult } from "../components/common/tvm-form/form-definition";
import resolveDb from "../db";
import { DbInstance, PARTITION_KEY } from "../utils/constants";
import { omit } from "ramda";

const db = resolveDb(DbInstance.JSON_DB);

export async function getSystemForm<T>(systemId: string, formId: string) {
	const formResult = await db.find<TvmFormSubmitResult<T>>((key) =>
		key.startsWith(`${formId}.${PARTITION_KEY}::${systemId}`)
	);
	return formResult?.length ? formResult[0] : null;
}

export async function setSystemForm<T>(
	systemId: string,
	formId: string,
	fieldValues: TvmFormSubmitResult<T>
) {
	await db.update(`${formId}.${PARTITION_KEY}::${systemId}`, fieldValues);
	return {
		_fields: omit(["_evaluationResult", "_flags"], fieldValues),
		_evaluationResult: fieldValues._evaluationResult,
		_flags: fieldValues._flags,
	};
}
